import { Typography } from '@mui/material';
import { FC, SyntheticEvent, useCallback, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { useAppStore } from '../../app/api/app-api';
import { AppPages, navigate } from '../../common/routing/app-navigator';
import { useAppOwners } from '../../application-owners/api/applications-owners-api';
import EmptyPageAvatar from '../../common/components/EmptyPageAvatar';
import InventoryFiltersStore from '../../dashboard-inventory/stores/inventory-filters-store';
import TopBarStore from '../../app/stores/top-bar-store';
import {
  handleFilterBy,
  loadTopIssues,
} from '../../issues/top-issues/actions/top-issues-actions';
import { useTopIssues } from '../../issues/top-issues/api/top-issues-api';
import { useGradualUpdate } from '../../new-scan/actions/scan-actions';
import { loadSupplyChain } from '../../supply-chain/actions/supply-chain-actions';
import { loadDashboardInfo } from '../actions/executive-summary-actions';
import { fetchIssuesScore } from '../actions/issues-graph-actions';
import ExecutiveStore from '../stores/executive-store';
import { fetchIssuesPrioritization } from '../actions/issues-prioritization-actions';

const update = () => {
  fetchIssuesScore();
  fetchIssuesPrioritization();
  loadSupplyChain();
  handleFilterBy();
  loadTopIssues();
  loadDashboardInfo();
};

const ExecutiveSummaryPageAvatarContainer: FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const { topIssues } = useTopIssues();
  const { supplyChainItems, issuesScore, orgScanInfoBreakdownInfo } =
    useSnapshot(ExecutiveStore);
  const { isEmptyOrg } = useAppStore();
  const { filters } = useSnapshot(InventoryFiltersStore);
  const { dateRange } = useSnapshot(TopBarStore);
  const { displaySelectedAppOwners } = useAppOwners();
  useEffect(() => {
    update();
  }, [filters, dateRange, displaySelectedAppOwners]);

  const { inProgress } = useGradualUpdate(update);
  const hasData =
    orgScanInfoBreakdownInfo ||
    topIssues.length ||
    issuesScore ||
    supplyChainItems?.length;

  const handleClickConnectors = useCallback(
    (e: SyntheticEvent<HTMLElement>) => {
      e.preventDefault();
      navigate(AppPages.Connectors);
    },
    [],
  );

  if (isEmptyOrg && !inProgress) {
    return (
      <EmptyPageAvatar
        text={
          <>
            Please run a scan to discover application security risks in your
            organization. To run a scan...
            <Typography
              variant='body1'
              color='text.primary'
              component='a'
              onClick={handleClickConnectors}
              href={AppPages.Connectors}
              mt={1}
              style={{ display: 'block', fontWeight: 'bold', color: '#FFF' }}>
              Connect your Git projects
            </Typography>
          </>
        }
      />
    );
  }

  if (inProgress && !hasData) {
    return (
      <EmptyPageAvatar
        text={
          <>
            A scan is now running. The first results will appear soon so don't
            MOOOOve.
          </>
        }
      />
    );
  }

  return <>{children}</>;
};

export default ExecutiveSummaryPageAvatarContainer;
